import { getCSSRules } from '@wordpress/style-engine';
export function parseInlineStyles(styles) {
    const output = {};
    getCSSRules(styles).forEach((rule) => {
        output[rule.key] = rule.value;
    });
    return output;
}
/**
 * Parses and returns any inline css styles on this block attributes
 * @param attributes Block Attributes object
 * @returns React CSS Properties object
 */
export default function getInlineStyles(attributes) {
    let styles;
    // Duck Typing
    if (attributes === null || attributes === void 0 ? void 0 : attributes.style) {
        try {
            styles = parseInlineStyles(JSON.parse(attributes === null || attributes === void 0 ? void 0 : attributes.style));
        }
        catch (e) {
            return styles;
        }
    }
    return styles;
}
